const newModel = () => {
    return {
        thethaoThanhtichDongdoiId: null,
        thethaoGiaithidauId: null,
        tenThethaoGiaithidau: null,
        thethaoBomonId: null,
        tenThethaoBomon: null,
        thethaoHangcanId: null,
        tenThethaoHangcan: null,
        thethaoThanhtichId: null,
        tenThethaoThanhtich: null,
        thethaoDoiId: null,
        tenThethaoDoi: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        // dateCreated: null,
        // userCreated: null,
        // dateModified: null,
        // userModified: null,
        // isDeleted: null,
        // userDeleted: null,
        // dateDeleted: null,
        // tenUserCreated: null,
        // tenUserModified: null,
        // tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        thethaoThanhtichDongdoiId: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        thethaoThanhtichId: null,
        thethaoDoiId: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
        // iocId: null,
        // iocEnabled: null,
        // iocEnabledDisplay: null,
        // iocDateUpdated: null,
    }
}

const fromJson = (item) => {
    return {
        thethaoThanhtichDongdoiId: item.thethaoThanhtichDongdoiId,
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        tenThethaoGiaithidau: item.tenThethaoGiaithidau,
        thethaoBomonId: item.thethaoBomonId,
        tenThethaoBomon: item.tenThethaoBomon,
        thethaoHangcanId: item.thethaoHangcanId,
        tenThethaoHangcan: item.tenThethaoHangcan,
        thethaoThanhtichId: item.thethaoThanhtichId,
        tenThethaoThanhtich: item.tenThethaoThanhtich,
        thethaoDoiId: item.thethaoDoiId,
        tenThethaoDoi: item.tenThethaoDoi,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoThanhtichDongdoiId: item.thethaoThanhtichDongdoiId,
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        thethaoBomonId: item.thethaoBomonId,
        thethaoHangcanId: item.thethaoHangcanId,
        thethaoThanhtichId: item.thethaoThanhtichId,
        thethaoDoiId: item.thethaoDoiId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        thethaoThanhtichDongdoiId: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        thethaoThanhtichId: null,
        thethaoDoiId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newSearchModel = (item) => {
    return {
        thethaoThanhtichDongdoiId: item.thethaoThanhtichDongdoiId,
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        thethaoBomonId: item.thethaoBomonId,
        thethaoHangcanId: item.thethaoHangcanId,
        thethaoThanhtichId: item.thethaoThanhtichId,
        thethaoDoiId: item.thethaoDoiId,
        enabled: item.enabled,
    }
}


const errors = () => {
    return {
        thethaoThanhtichDongdoiId: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        thethaoThanhtichId: null,
        thethaoDoiId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

export const doiTheThaoThanhTichModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


